import React from "react";
import { QRCodeSVG } from "qrcode.react";
import { CalendarDays, Clock, MapPin, Printer, Sparkles } from "lucide-react";

const TIERS = [
  { name: "General", price: "$90", line: "Main floor — the easiest way to be in the room" },
  { name: "Select", price: "$129", line: "Closer to the front, direct stage view" },
  { name: "Select+ · Meet & Greet", price: "$149", line: "Front section + meet & greet / photo op with Susan" },
  { name: "VIP Experience", price: "$1,000", line: "First 2 rows + private after-show group reading · only 64 seats" },
];

const Flyer = () => {
  const url = `${window.location.origin}`;
  return (
    <div className="min-h-screen bg-[#05070F] py-6 print:py-0 flex flex-col items-center">
      <button
        onClick={() => window.print()}
        data-testid="flyer-print-button"
        className="mb-5 print:hidden inline-flex items-center gap-2 btn-gold rounded-full px-6 py-3 text-sm font-bold"
      >
        <Printer size={15} /> Print / Save as PDF
      </button>

      <div
        data-testid="flyer-sheet"
        className="flyer-sheet relative w-[8.5in] h-[11in] bg-[#0B1021] text-center overflow-hidden shadow-2xl"
        style={{ printColorAdjust: "exact", WebkitPrintColorAdjust: "exact" }}
      >
        {/* glow */}
        <div className="absolute -top-32 left-1/2 -translate-x-1/2 w-[120%] h-80 rounded-[100%] bg-[#1d1b4b] blur-3xl opacity-70" />

        <div className="relative px-12 pt-10 pb-8 h-full flex flex-col">
          <img src="/images/logo-sg.png" alt="SG" className="w-20 h-20 mx-auto" />

          <p className="mt-5 text-[11px] uppercase tracking-[0.35em] text-[#8A99B5]">
            An Evening of Mediumship
          </p>
          <h1 className="font-display text-[44px] leading-[1.02] text-[#F8F9FA] mt-3">
            A View<br />from the Top
          </h1>
          <p className="font-display italic text-[34px] text-gold-gradient leading-none mt-1">LIVE</p>
          <p className="text-[15px] uppercase tracking-[0.3em] text-[#F3D068] mt-3">
            with Susan Grau
          </p>
          <p className="mt-3 text-[10px] uppercase tracking-[0.22em] text-[#C5CEE0]">
            Live TV Show Taping · New Year 2027 Premiere
          </p>

          <div className="flex items-center justify-center gap-x-6 gap-y-2 flex-wrap mt-6 text-[12px] text-[#FDFBF7]">
            <span className="flex items-center gap-2"><CalendarDays size={14} className="text-[#D4AF37]" /> Thursday, January 14, 2027</span>
            <span className="flex items-center gap-2"><Clock size={14} className="text-[#D4AF37]" /> Doors 6 PM · Show 7 PM</span>
            <span className="flex items-center gap-2"><MapPin size={14} className="text-[#D4AF37]" /> The Saban Theatre, Beverly Hills</span>
          </div>

          <div className="hairline mt-6" />

          <div className="mt-5 space-y-2.5 text-left">
            {TIERS.map((t) => (
              <div
                key={t.name}
                data-testid={`flyer-tier-${t.name.split(" ")[0].toLowerCase()}`}
                className="flex items-center justify-between gap-4 rounded-xl border border-[#D4AF37]/25 bg-[#D4AF37]/[0.04] px-5 py-3"
              >
                <div>
                  <p className="font-display text-[17px] text-[#F8F9FA] leading-tight">{t.name}</p>
                  <p className="text-[11px] text-[#8A99B5] mt-0.5 leading-snug">{t.line}</p>
                </div>
                <p className="font-display text-[24px] text-gold-gradient whitespace-nowrap">{t.price}</p>
              </div>
            ))}
          </div>

          <p className="mt-5 text-[12px] text-[#C5CEE0] font-light italic leading-relaxed px-4">
            "The people we lose are never as far as they seem."
          </p>

          <div className="mt-auto flex items-center justify-between gap-6 pt-5">
            <div className="text-left">
              <p className="text-[11px] text-[#F3D068] font-medium">Tickets & info</p>
              <p className="text-[10px] text-[#C5CEE0] mt-0.5">susangrau.com · @susangrauofficial</p>
              <p className="text-[10px] text-[#8A99B5] mt-1 flex items-center gap-1.5">
                <Sparkles size={10} className="text-[#D4AF37]" /> Give it as a Christmas gift — seats for the new year
              </p>
              <p className="text-[9px] text-[#8A99B5]/70 mt-2">Site created by M Media Corp</p>
            </div>
            <div className="bg-white rounded-xl p-2 shrink-0">
              <QRCodeSVG value={url} size={84} bgColor="#FFFFFF" fgColor="#0B1021" />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Flyer;
